import { NEW } from "../components/utility/constants";

export function isNotValidDetailPageView(token, id) {
    return isNaN(+id) || +id < 0 || !token;
}

export function hasInvalidNewAndDetailPerms(token, perms, entityID) {
    return ( entityID === NEW ? !perms?.create : (isNotValidDetailPageView(token, entityID) || !perms?.read) );
}